import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Phone from "react-phone-input-2";
import IoEyeOffSharp from "../../../assets/icons/eyeClosed";
import IoEyeOutline from "../../../assets/icons/eyeOpen";

export const PasswordInput = ({
  id = "",
  placeholder = "Enter Password",
  name,
  value = "",
  onChange = () => {},
  isDisabled = false,
}) => {
  const [showPass, setShowPass] = useState(false);

  const handlePassVisibility = () => {
    setShowPass(!showPass);
  };

  return (
    <div className="position-relative">
      <input
        type={showPass ? "text" : "password"}
        id={id || name}
        className="form-control shadow-none"
        placeholder={placeholder}
        disabled={isDisabled}
        name={name}
        value={value}
        onChange={onChange}
      />
      <Button variant="" className="eye_btn" onClick={handlePassVisibility}>
        {showPass ? <IoEyeOffSharp /> : <IoEyeOutline />}
      </Button>
    </div>
  );
};

export const PhoneInput = ({
  inputClassName = "w-100",
  buttonClassName = "",
  placeholder = "Enter Phone Number",
  isDisabled = false,
  name,
  value = "",
  onChange = () => {},
}) => {
  return (
    <Phone
      inputClass={inputClassName}
      buttonClass={buttonClassName}
      inputStyle={{ height: 38 }}
      country="in"
      placeholder={placeholder}
      disabled={isDisabled}
      value={value}
      onChange={(value, data, e, formattedValue) => {
        onChange(name, formattedValue);
      }}
    />
  );
};

export const TextInput = ({
  type = "text",
  isDisabled = false,
  placeholder = "",
  name,
  value = "",
  onChange = () => {},
}) => {
  return (
    <input
      className="form-control shadow-none"
      type={type}
      id={name}
      placeholder={placeholder}
      disabled={isDisabled}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};
